import React from "react";
import styled, { withTheme } from "styled-components";
import { Col } from "antd";
import { Metrics, Colors, Icons } from "../../theme";

export const SimpleText = styled.p`
    ${props=>props.singleLine ? `
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    ` : ""}
    ${props=>props.color ? `
        color:${props.color};
    `:""}
    ${props=>props.fontSize ? `
        font-size:${props.fontSize}px;
    `:""}
`;
export const SingleLine = styled.p`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    ${props=>props.color ? `
        color:${props.color};
    `:""}
    ${props=>props.fontSize ? `
        font-size:${props.fontSize}px;
    `:""}
`;
export const ColumnLabel = styled(Col)`
    font-size: ${Metrics.fontSize.content}px;
    font-weight: ${Metrics.boldFontWeight};
    margin-right: ${Metrics.button.bigSpaceMargin}px;
`;
export const OH1 = styled.p`
    font-size: ${Metrics.fontSize.h1}px;
    font-weight: ${Metrics.boldFontWeight};
`;
export const OHeader = styled.p`
    font-size: ${Metrics.fontSize.header}px;
    font-weight: ${Metrics.boldFontWeight};
    ${props=>props.singleLine ? `
        text-overflow:ellipsis;
        overflow: hidden; 
        white-space: nowrap;
    `:""}
    ${props=>props.onClick ? `
        cursor:pointer;
    ` : ""}
`;
export const OThemeText = withTheme(styled.p`
    color: ${props=>props.theme.mainColor || "#000000"};
    margin-bottom:0px;
`);
export const OButtonText = withTheme(styled.p`
    color: ${props=>props.theme.button.textColor || "#FFFFFF"};
    margin-bottom:0px;
`);
export const IncrementTextType = {
	UP:"up",
	DOWN:"down",
	EQUALS:"equals"
};

const TextMiddle = styled.p`
    line-height:1.5;
    ${props=>props.color ? `
        color:${props.color};
    ` : ""}
`;

export const IncrementText = ({ type, value, style })=>{
	const { ArrowUp, ArrowDown } = Icons;
	switch(type){
	case IncrementTextType.UP:
		return <ArrowUp style={{...style,color:Colors.green, display:"flex", lineHeight:1.5}}>{value}</ArrowUp>;
	case IncrementTextType.DOWN:
		return <ArrowDown style={{...style,color:Colors.red, display:"flex", lineHeight:1.5}}>{value}</ArrowDown>;
		/**
         * EQUALS
         */
	default:
		return <TextMiddle style={{...style}}>
			{value}
		</TextMiddle>;
	}
	return undefined;
};

export const TooltipText = styled.p`
    color:${props=>Colors.unimportantFontAlphaColor};
`;
const TooltipBoxContainer = styled.div`
    text-align:center;
    justify-content:center;
    display: flex;
    height:'100%';
`;
export const TooltiptextBox = ({style, children})=>{
	return <div style={{textAlign:"center", display:"flex", justifyContent:"center", height:"100%",...style}}>
		<TooltipText style={{alignSelf:"center"}}>{children}</TooltipText>
	</div>;
};


// WEBPACK FOOTER //
// ./src/components/text/OText.js